import Link from 'next/link'
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { PxToVw } from '@/utils/convertPx'
import { LEGAL_ROUTE } from '@/utils/enroutes'

import { Button } from '@/components/elements/Button'
import { ImageTitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'

export const LegalPage = () => {
  return (
    <LegalMain>
      <LegalLinks>
        {LEGAL_ROUTE.subdirectories.map(({ name, path }) => (
          <Link href={path} passHref key={name}>
            <a>
              <Button btnStyle="normal">{name}</Button>
            </a>
          </Link>
        ))}
      </LegalLinks>
    </LegalMain>
  )
}

LegalPage.getLayout = function getLayout(page: ReactElement) {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '' },
  ]

  return (
    <>
      <Head
        title="Legal"
        description="The legal contents related to TRIAL Holdings, Inc."
        ogp={{ url: 'en/legal/' }}
      />
      <ImageTitleLayout
        title=""
        subTitle=""
        enTitle="Legal"
        imgUrl="/images/top-legal.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const LegalMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 96px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 40px 20px 70px;
  }
`

const LegalLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 50px 43px;

  button {
    width: 318px;
  }

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    align-items: center;
    gap: 24px 0;

    button {
      width: ${PxToVw(314, 390)};
      max-width: 314px;
      height: 36px;
    }
  }
`
